/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint, $autoplay, $autoplayspeed) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: $arrows,
    autoplay: $autoplay,
    autoplaySpeed: $autoplayspeed,
    infinite: false,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: "0",
    variableWidth: true,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}

mobileOnlySlider(".zoelu-club-text-blocks_blocks", true, false, 999, false, 1000);

$(window).on("scroll", function () {
  if (window.innerWidth < 767) {
    if ($(window).scrollTop() > 25) {
      $("body").addClass("scrolling");
    } else {
      $("body").removeClass("scrolling");
    }
  }
});

$(".header--transparent").on("click", function () {
  if (window.innerWidth < 767) {
    if ($(".header").hasClass("header--transparent") == false) {
      $("body").addClass("scrolling");
    }
  }
});

$(document).ready(function () {
  $("span.custom_color_swatch_item").click(function () {
    $(".custom_color_swatch_item").removeClass("active");
    $(this).addClass("active");
    var product_img1 = $(this).attr("product_img1");
    var product_img2 = $(this).attr("product_img2");
    var product_link = $(this).attr("product_link");
    var product_price = $(this).attr("product_price");
    var product_item = $(this).closest(".product-item");

    product_item.find(".product-item__primary-image").attr("src", product_img1);
    product_item.find(".product-item__primary-image").removeAttr("srcset");
    product_item.find(".product-item__secondary-image").attr("src", product_img2);
    product_item.find(".product-item__secondary-image").removeAttr("srcset");
    product_item.find("a.product-item__aspect-ratio").attr("href", product_link);
    product_item.find(".product-item-meta__clr").text($(this).attr("meta_color"));
    product_item.find(".product-item-meta .price-list price-list--centered .price").text(product_price);
    product_item.find(".product-item-meta a").attr("href", product_link);
  });

  //------------------------ Drawer Add to Cart -------------------------------------

  $(document).on("click", ".product-item__cta", function (e) {
    e.preventDefault();
    $(this).prop("disabled");

    var variantId = $(this).data("product-id");
    var quantity = 1;

    var data = {
      items: [
        {
          id: variantId,
          quantity: quantity,
        },
      ],
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (response) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      },
      error: function (xhr, status, error) {
        console.log("There was an error adding the item to the cart.");
      },
    });
  });

  //------------------------ Drawer Add to Cart -------------------------------------

  document.addEventListener("cart:updated", async function (event) {
    var $freeShippingBar = $(".free_shipping_bar");
    const productThersold1 = parseInt($freeShippingBar.attr("product_thersold_1"), 10);
    const productId1 = $freeShippingBar.attr("product_id_1");
    const productThersold2 = parseInt($freeShippingBar.attr("product_thersold_2"), 10);
    const productId2 = $freeShippingBar.attr("product_id_2");

    // Ensure that at least one product is defined
    if (!productId1 && !productId2) return;

    try {
      setTimeout(async function () {
        const cart = await fetch("/cart.js").then((res) => res.json());
        const cartTotal = cart.total_price;
        console.log("checking");
        if (productId2 && cartTotal > productThersold2) {
          //await handleProductRemoval_1(productId1,productId2);
        } else if (productId1 && cartTotal < productThersold1) {
          console.log("remove all");
          await removeProducts([productId1, productId2]);
        } else if (productId1 && cartTotal > productThersold1) {
          await handleProductRemoval(productId2);
        }
      }, 250);
    } catch (error) {
      console.error("Error fetching cart data:", error);
    }
  });
  //}

  // Handle removal of a single product from the cart
  async function handleProductRemoval(productId) {
    if (!productId) return;
    try {
      const cart = await fetch("/cart.js").then((res) => res.json());
      const productInCart = cart.items.find((item) => item.variant_id == productId);
      if (productInCart) {
        await removeFromCart(productId);
      }
    } catch (error) {
      console.error("Error checking product in cart:", error);
    }
  }

  // Handle removal of a single product from the cart
  async function handleProductRemoval_1(productId, productId_2) {
    if (!productId || !productId_2) return;
    try {
      const cart = await fetch("/cart.js").then((res) => res.json());
      const productInCart = cart.items.find((item) => item.variant_id == productId_2);
      if (productInCart) {
        await removeFromCart(productId);
      }
    } catch (error) {
      console.error("Error checking product in cart:", error);
    }
  }

  // Remove one or more products from the cart
  async function removeProducts(productIds) {
    const updates = {};
    productIds.forEach((id) => {
      if (id) updates[id] = 0;
    });

    if (Object.keys(updates).length === 0) return;

    try {
      await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      });
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    } catch (error) {
      console.error("Error removing product(s) from cart:", error);
    }
  }

  // Remove a product from the cart
  async function removeFromCart(variantId) {
    if (variantId) {
      const updates = { [variantId]: 0 };
      try {
        await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        });
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      } catch (error) {
        console.error("Error removing product from cart:", error);
      }
    }
  }
});

document.addEventListener("click", function (e) {
  if (window.innerWidth < 767) {
    if (!e.target.closest(".header")) {
      if ($(".header").hasClass("header--transparent") == true) {
        $("body").removeClass("scrolling");
      }
    }
  }
});

function cpProductSlider() {
  const sliders = document.querySelectorAll("[data-slider]");
  sliders.forEach((slider) => {
    const sliderInner = slider.querySelector(".cp-product-slider-inner");
    if (sliderInner && sliderInner.children.length > 1) {
      const config = JSON.parse(sliderInner.getAttribute("data-config"));
      new Flickity(sliderInner, config);
    }
  });
}
cpProductSlider();
